/**
 * Пароль резервных копий.
 *
 * Один пароль на все копии человека: файл шифруется им при каждой выгрузке —
 * ручной, ежедневной и на Яндекс.Диск. Спрашивать его на каждую копию нельзя,
 * ежедневная снимается сама и никого не будит.
 *
 * На телефоне пароль лежит в системном хранилище — Keychain или Keystore, — а
 * не в базе приложения. В браузере такого места нет, и там он остаётся в базе:
 * об этом сказано в настройках прямо.
 *
 * ## Почему пароль хранится здесь же, на устройстве
 *
 * Выглядит противоречиво: зачем шифровать, если ключ рядом? Затем, что
 * защищается не устройство, а файл, который его покинул. В облаке лежит
 * шифротекст, и человек, получивший доступ к чужому Яндекс.Диску, не получает
 * ничего. Тот, кто добрался до самого устройства, и без пароля прочитает базу
 * целиком — от него защищает не это.
 *
 * ## Почему по умолчанию выключено
 *
 * Забытый пароль означает, что копию не открыть уже никогда — ни нам, ни
 * человеку. Включить шифрование молча значило бы однажды оставить кого-то без
 * данных в тот самый день, когда он потерял телефон. Поэтому только вручную и
 * с прямым предупреждением.
 */

import { readSecret, removeSecret, writeSecret } from '@/shared/lib/secret-storage';

const passwordKey = (userId: string) => `backup.password:${userId}`;

/** Пароль копий или `null`, если шифрование не включено. */
export async function readBackupPassword(userId: string): Promise<string | null> {
  return readSecret(passwordKey(userId));
}

export async function setBackupPassword(userId: string, password: string): Promise<void> {
  await writeSecret(passwordKey(userId), password);
}

/**
 * Выключает шифрование.
 *
 * Уже снятые копии остаются зашифрованными: пароль от них человек должен
 * помнить сам. Сказать об этом — обязанность интерфейса.
 */
export async function forgetBackupPassword(userId: string): Promise<void> {
  await removeSecret(passwordKey(userId));
}
